<template>
	<v-container fluid class="mt-4 ml-2">

		<v-row>
			<v-col>
				Cajas al día de hoy {{fecha}}
			</v-col>
		</v-row>
		<v-row align="center" justify="center">
      <v-col cols="12"  align="center">
        <v-card class="shadowCard">
        	<v-card-text>
	          <v-data-table
	            :headers="headers"
	            :items="movimientos"
	            hide-default-footer
	            height="450"
	            fixed-header
	            :items-per-page="length"
	            >

	            <template v-slot:item.fecha="{item}">
	              <div >{{item.fecha.substr(0,10)}}</div>
	            </template>

	            <template v-slot:item.opciones="{item}">
	            	<v-tooltip bottom>
	  				      <template v-slot:activator="{ on, attrs }">
	  				      	<v-btn color="green" small icon
	  				      		v-bind="attrs"
	  				          v-on="on"
	  				          @click="abrirCaja(item)"
	  				      	><v-icon>mdi-check</v-icon></v-btn>
	  				      </template>
	  				      <span>Abrir</span>
	  				    </v-tooltip>
	            </template>

	          </v-data-table>
        	</v-card-text>
        </v-card>

      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

	</v-container>
</template>

<script>
	import {mapGetters, mapActions} from 'vuex'

	// import * as am4core from "@amcharts/amcharts4/core";
	// import * as am4charts from "@amcharts/amcharts4/charts";
	// import am4themes_animated from "@amcharts/amcharts4/themes/animated";
	// am4core.useTheme(am4themes_animated);
	// var numeral = require('numeral');

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

	export default{

		components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,
      
      fecha: new Date().toISOString().substr(0, 10),

			headers:[
        {text: 'Usuario'      , value:'nomuser'     },
        {text: 'Fecha'        , value:'fecha'       },
        {text: 'Hora'         , value:'hora'        },
        {text: 'Saldo inicial', value:'saldoinicial'},
        {text: 'Opciones'     , value:'opciones'    },
      ],

      movimientos:[],
      length: 5,

      snackbar: false,
      color:'success',
      text:'',
		}),

		created(){
			this.initialize()
		},

		computed:{
      ...mapGetters('login',['getdatosUsuario'])
    },

		methods:{
			initialize(){
				this.movimientos = []
				var payload = {fecha: this.fecha}
				this.$http.post('cajas.dia', payload).then(response=>{
					for(const i in response.body){
						if(response.body[i].idestatuscaja == null){
							response.body[i].saldoinicial = numeral(response.body[i].saldoinicial).format('0,0.00');
							this.movimientos.push(response.body[i])
						}
					}


					this.length = this.movimientos.length
					console.log(response.body)
				}).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
			},

			abrirCaja(value){
			 	var estatus = {
          idusuario: value.idusuario,
          idcaja: value.idcaja
        }

				this.$http.post('add.estatus.caja', estatus).then(response=>{
					this.$http.post('cierre.delete', estatus).then(response=>{
						this.text = 'Caja abierta'
						this.color = 'success'
						this.snackbar = true
						this.initialize()
					}).catch( error =>{
	          this.validarError( error )
	        }).finally( () => { this.cargar = false })
				}).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
			}
		}
	}
</script>